import { orderBy } from 'lodash';

export const shiftingMethodsList = ['add', 'subtract'];

export const timePeriodsList = ['day', 'month', 'year'];

export const dateTimeKeys = { start_of_period: 'start_of_period', end_of_period: 'end_of_period' };

export const dateTimeLabels = {
  [dateTimeKeys.start_of_period]: 'Start of Period',
  [dateTimeKeys.end_of_period]: 'End of Period'
};

export const dateTimeArray = [
  {
    value: dateTimeKeys.start_of_period,
    label: dateTimeLabels[dateTimeKeys.start_of_period]
  },
  {
    value: dateTimeKeys.end_of_period,
    label: dateTimeLabels[dateTimeKeys.end_of_period]
  }
];

export const conditionKeys = {
  OR: 'or',
  AND: 'and'
};

export const conditionLabels = {
  [conditionKeys.OR]: 'Or',
  [conditionKeys.AND]: 'And'
};

export const conditionsArray = [
  {
    value: conditionKeys.AND,
    label: conditionLabels[conditionKeys.AND]
  },
  {
    value: conditionKeys.OR,
    label: conditionLabels[conditionKeys.OR]
  }
];

export const transportationKeys = {
  FILTER: 'filter',
  REPLACE: 'replace',
  FILL_FORWARD: 'fill_forward',
  ABSOLUTE: 'absolute',
  ADD_COLUMN: 'add_column',
  REMOVE_DUPLICATES: 'remove_duplicates',
  RENAME_COLUMNS: 'rename_columns',
  ARITHMETIC: 'math',
  SPLIT: 'split_column_values',
  CONCATENATE: 'concatenate',
  JOIN: 'join',
  NEGATIVE: 'negative',
  SUBSTITUTE: 'replace_text',
  SUM_IF: 'sum_if',
  DUPLICATE_ROWS: 'duplicate_rows',
  DATE_SHIFTING: 'date_shifting',
  CHANGE_DATA_TYPES: 'change_data_types',
  SPLIT_BY_VALUE: 'split'
};

export const transportationLabels = {
  [transportationKeys.ABSOLUTE]: 'Absolute',
  [transportationKeys.ARITHMETIC]: 'Arithmetic',
  [transportationKeys.CONCATENATE]: 'Concatenate',
  [transportationKeys.ADD_COLUMN]: 'Create Column',
  [transportationKeys.FILTER]: 'Filter',
  [transportationKeys.FILL_FORWARD]: 'Fill In',
  [transportationKeys.JOIN]: 'Join',
  [transportationKeys.NEGATIVE]: 'Negative',
  [transportationKeys.REPLACE]: 'Replace',
  [transportationKeys.REMOVE_DUPLICATES]: 'Remove Duplicates',
  [transportationKeys.RENAME_COLUMNS]: 'Rename Columns',
  [transportationKeys.SPLIT]: 'Split Column Values',
  [transportationKeys.SUBSTITUTE]: 'Replace Text',
  [transportationKeys.SUM_IF]: 'Sum If',
  [transportationKeys.DUPLICATE_ROWS]: 'Duplicate Rows',
  [transportationKeys.DATE_SHIFTING]: 'Date Shifting',
  [transportationKeys.CHANGE_DATA_TYPES]: 'Change Data Types',
  [transportationKeys.SPLIT_BY_VALUE]: 'Split'
};

const _transportationsArray = [
  {
    value: transportationKeys.REPLACE,
    label: transportationLabels[transportationKeys.REPLACE]
  },
  {
    value: transportationKeys.FILTER,
    label: transportationLabels[transportationKeys.FILTER]
  },
  {
    value: transportationKeys.FILL_FORWARD,
    label: transportationLabels[transportationKeys.FILL_FORWARD]
  },
  {
    value: transportationKeys.ABSOLUTE,
    label: transportationLabels[transportationKeys.ABSOLUTE]
  },
  {
    value: transportationKeys.ADD_COLUMN,
    label: transportationLabels[transportationKeys.ADD_COLUMN]
  },
  {
    value: transportationKeys.DUPLICATE_ROWS,
    label: transportationLabels[transportationKeys.DUPLICATE_ROWS]
  },
  {
    value: transportationKeys.DATE_SHIFTING,
    label: transportationLabels[transportationKeys.DATE_SHIFTING]
  },
  {
    value: transportationKeys.REMOVE_DUPLICATES,
    label: transportationLabels[transportationKeys.REMOVE_DUPLICATES]
  },
  {
    value: transportationKeys.RENAME_COLUMNS,
    label: transportationLabels[transportationKeys.RENAME_COLUMNS]
  },
  {
    value: transportationKeys.SUBSTITUTE,
    label: transportationLabels[transportationKeys.SUBSTITUTE]
  },
  {
    value: transportationKeys.ARITHMETIC,
    label: transportationLabels[transportationKeys.ARITHMETIC]
  },
  {
    value: transportationKeys.SPLIT,
    label: transportationLabels[transportationKeys.SPLIT]
  },
  {
    value: transportationKeys.CONCATENATE,
    label: transportationLabels[transportationKeys.CONCATENATE]
  },
  {
    value: transportationKeys.JOIN,
    label: transportationLabels[transportationKeys.JOIN]
  },
  {
    value: transportationKeys.NEGATIVE,
    label: transportationLabels[transportationKeys.NEGATIVE]
  },
  {
    value: transportationKeys.SUM_IF,
    label: transportationLabels[transportationKeys.SUM_IF]
  },
  {
    value: transportationKeys.CHANGE_DATA_TYPES,
    label: transportationLabels[transportationKeys.CHANGE_DATA_TYPES]
  },
  {
    value: transportationKeys.SPLIT_BY_VALUE,
    label: transportationLabels[transportationKeys.SPLIT_BY_VALUE]
  }
];

export const transportationsArray = orderBy(_transportationsArray, ['label'], ['asc']);

export const transformationTooltips = {
  [transportationKeys.ABSOLUTE]:
    'Change all the values in a column to their absolute values, ensuring no negative values remain.',
  [transportationKeys.ADD_COLUMN]:
    'Add a new column to your table, either with initial values or by deriving its content from existing columns.',
  [transportationKeys.ARITHMETIC]:
    'Execute mathematical operations such as  addition, subtraction, multiplication, and division.',
  [transportationKeys.CONCATENATE]:
    'Combine the contents of two or more string columns into a single column, merging their values for streamlined data presentation.',
  [transportationKeys.FILL_FORWARD]:
    'Automatically replicate the last value down a column until a new entry appears.',
  [transportationKeys.FILTER]: 'Selectively retain rows based on adherence to defined conditions.',
  [transportationKeys.JOIN]:
    'Combine two tables based on a shared column, allowing you to consolidate related data from different sources.',
  [transportationKeys.REMOVE_DUPLICATES]:
    'Remove duplicate rows from the data, ensuring each row is unique based on specified columns.',
  [transportationKeys.RENAME_COLUMNS]:
    'Delete specified columns from the data, simplifying your data and focusing on relevant information.',
  [transportationKeys.REPLACE]:
    'Change every instance of a specified value in a column with a new value.',
  [transportationKeys.SPLIT]: 'Divide values in a column based on conditions you provide.',
  [transportationKeys.NEGATIVE]: 'Converts the value to its negative counterpart',
  [transportationKeys.SUBSTITUTE]: 'Replace specified text in a string with new text.',
  [transportationKeys.SUM_IF]:
    'Aggregates rows with identical non-numeric values by summing their numeric columns.',
  [transportationKeys.DUPLICATE_ROWS]: 'Duplicate rows when conditions are met',
  [transportationKeys.DATE_SHIFTING]: 'Divide values in a column based on conditions you provide.',
  [transportationKeys.CHANGE_DATA_TYPES]:
    'Change the data type of a column to a different type, such as converting text to numbers or dates.',
  [transportationKeys.SPLIT_BY_VALUE]:
    'Splits the selected column keeping only the first part of the text up to the specified delimiter.'
};

export const duplicateActionTypes = {
  FIRST: 'first',
  LAST: 'last',
  FALSE: 'false'
};

export const duplicateActionTypesArray = [
  {
    label: 'Keep First Row',
    value: duplicateActionTypes.FIRST,
    tooltip: 'When duplicates are found, only the first row in each duplicate group will be kept.'
  },
  {
    label: 'Keep Last Row',
    value: duplicateActionTypes.LAST,
    tooltip: 'When duplicates are found, only the last row in each duplicate group will be kept.'
  },
  {
    label: 'Remove All Duplicates',
    value: duplicateActionTypes.FALSE,
    tooltip: 'When duplicates are found, all rows identified as duplicates will be deleted.'
  }
];

export const dataTypeKeys = {
  FLOAT: 'float',
  INTEGER: 'integer',
  STRING: 'string',
  DATE: 'date',
  BOOLEAN: 'boolean'
};

export const dataTypeLabels = {
  [dataTypeKeys.FLOAT]: 'Number',
  [dataTypeKeys.INTEGER]: 'Integer',
  [dataTypeKeys.STRING]: 'Text',
  [dataTypeKeys.DATE]: 'Date',
  [dataTypeKeys.BOOLEAN]: 'Boolean'
};

export const dataTypeKeysFromLabel = {
  Number: dataTypeKeys.FLOAT,
  Integer: dataTypeKeys.INTEGER,
  Text: dataTypeKeys.STRING,
  Date: dataTypeKeys.DATE,
  Boolean: dataTypeKeys.BOOLEAN
};

export const dataTypeArray = [
  {
    value: dataTypeKeys.FLOAT,
    label: dataTypeLabels[dataTypeKeys.FLOAT]
  },
  {
    value: dataTypeKeys.INTEGER,
    label: dataTypeLabels[dataTypeKeys.INTEGER]
  },
  {
    value: dataTypeKeys.STRING,
    label: dataTypeLabels[dataTypeKeys.STRING]
  },
  {
    value: dataTypeKeys.DATE,
    label: dataTypeLabels[dataTypeKeys.DATE]
  },
  {
    value: dataTypeKeys.BOOLEAN,
    label: dataTypeLabels[dataTypeKeys.BOOLEAN]
  }
];

export const dateFormatKeys = {
  YMD_HMS: '%Y-%m-%d %H:%M:%S',
  YMD_DASH: '%Y-%m-%d',
  YMD_SLASH: '%Y/%m/%d',
  DMY_DASH: '%d-%m-%Y',
  DMY_SLASH: '%d/%m/%Y',
  MDY_DASH: '%m-%d-%Y',
  MDY_SLASH: '%m/%d/%Y',
  MDY_DOT: '%m.%d.%Y',
  MDY_SPACE: '%m %d %Y',
  MDY_COMMA: '%b %d, %Y',
  MDY_LONG_COMMA: '%B %d, %Y',
  DMY_MON: '%d %b %Y',
  DMY_MONTH: '%d %B %Y',
  YMD_DOT: '%Y.%m.%d',
  DMY_DOT: '%d.%m.%Y',
  YMD_COMPACT: '%Y%m%d',
  DMY_COMPACT: '%d%m%Y',
  YMD_SPACE: '%Y %m %d',
  MDY_SPACE2: '%m %d %Y'
};

export const dateFormatLabels = {
  [dateFormatKeys.YMD_HMS]: 'yyyy-mm-dd hh:mm:ss',
  [dateFormatKeys.YMD_DASH]: 'yyyy-mm-dd',
  [dateFormatKeys.YMD_SLASH]: 'yyyy/mm/dd',
  [dateFormatKeys.DMY_DASH]: 'dd-mm-yyyy',
  [dateFormatKeys.DMY_SLASH]: 'dd/mm/yyyy',
  [dateFormatKeys.MDY_DASH]: 'mm-dd-yyyy',
  [dateFormatKeys.MDY_SLASH]: 'mm/dd/yyyy',
  [dateFormatKeys.MDY_COMMA]: 'Mon dd, yyyy (e.g. Jun 20, 2025)',
  [dateFormatKeys.MDY_LONG_COMMA]: 'Month dd, yyyy (e.g. June 20, 2025)',
  [dateFormatKeys.DMY_MON]: 'dd Mon yyyy (e.g. 20 Jun 2025)',
  [dateFormatKeys.DMY_MONTH]: 'dd Month yyyy (e.g. 20 June 2025)',
  [dateFormatKeys.YMD_DOT]: 'yyyy.mm.dd',
  [dateFormatKeys.DMY_DOT]: 'dd.mm.yyyy',
  [dateFormatKeys.YMD_COMPACT]: 'yyyymmdd',
  [dateFormatKeys.DMY_COMPACT]: 'ddmmyyyy',
  [dateFormatKeys.YMD_SPACE]: 'yyyy mm dd',
  [dateFormatKeys.MDY_SPACE2]: 'mm dd yyyy'
};

export const dateFormatKeysFromLabel = {
  [dateFormatLabels[dateFormatKeys.YMD_HMS]]: dateFormatKeys.YMD_HMS,
  [dateFormatLabels[dateFormatKeys.YMD_DASH]]: dateFormatKeys.YMD_DASH,
  [dateFormatLabels[dateFormatKeys.YMD_SLASH]]: dateFormatKeys.YMD_SLASH,
  [dateFormatLabels[dateFormatKeys.DMY_DASH]]: dateFormatKeys.DMY_DASH,
  [dateFormatLabels[dateFormatKeys.DMY_SLASH]]: dateFormatKeys.DMY_SLASH,
  [dateFormatLabels[dateFormatKeys.MDY_DASH]]: dateFormatKeys.MDY_DASH,
  [dateFormatLabels[dateFormatKeys.MDY_SLASH]]: dateFormatKeys.MDY_SLASH,
  [dateFormatLabels[dateFormatKeys.MDY_DOT]]: dateFormatKeys.MDY_DOT,
  [dateFormatLabels[dateFormatKeys.MDY_SPACE]]: dateFormatKeys.MDY_SPACE,
  [dateFormatLabels[dateFormatKeys.MDY_COMMA]]: dateFormatKeys.MDY_COMMA,
  [dateFormatLabels[dateFormatKeys.MDY_LONG_COMMA]]: dateFormatKeys.MDY_LONG_COMMA,
  [dateFormatLabels[dateFormatKeys.DMY_MON]]: dateFormatKeys.DMY_MON,
  [dateFormatLabels[dateFormatKeys.DMY_MONTH]]: dateFormatKeys.DMY_MONTH,
  [dateFormatLabels[dateFormatKeys.YMD_DOT]]: dateFormatKeys.YMD_DOT,
  [dateFormatLabels[dateFormatKeys.DMY_DOT]]: dateFormatKeys.DMY_DOT,
  [dateFormatLabels[dateFormatKeys.YMD_COMPACT]]: dateFormatKeys.YMD_COMPACT,
  [dateFormatLabels[dateFormatKeys.DMY_COMPACT]]: dateFormatKeys.DMY_COMPACT,
  [dateFormatLabels[dateFormatKeys.YMD_SPACE]]: dateFormatKeys.YMD_SPACE,
  [dateFormatLabels[dateFormatKeys.MDY_SPACE2]]: dateFormatKeys.MDY_SPACE2
};

export const dateFormatArray = Object.keys(dateFormatLabels).map(key => ({
  value: dateFormatKeysFromLabel[key],
  label: dateFormatLabels[key]
}));

export const FILL_TYPES = {
  UP: 'up',
  FORWARD: 'forward'
};

export const fillTypesArray = [
  {
    value: FILL_TYPES.UP,
    label: 'Up'
  },
  {
    value: FILL_TYPES.FORWARD,
    label: 'Forward'
  }
];
